import Progress from '../../stacks/progress/ProgressAWS';

const CheckProgress =  async function CheckProgress(part) {
    try {
      const progressApi = Progress.getInstance();
      const progress = await progressApi.retrieve()
      const prog = progress && progress[part]
      if (prog === undefined
        || prog === 'unavailable'
        || ( part !== 'report' && prog === 'completed' )) {
        return false
      }
      return true
    }
    catch (err) {
        console.error(`Failed to get progress: ${err.message}`)
        return false
    }
}

export default CheckProgress
  